import { FaWhatsapp } from "react-icons/fa";
import "./wpbutton.css";

const WhatsappButton = () => {
  return (
    <a
      href="https://wa.me/37493106810"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsappButton;